import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Constants from 'root/constants';
import Util from 'root/module/util';
import Form from 'root/module/form';
import Collection_History from 'collection/history';
import View from 'view/base';
import View_Feedback_History from 'view/feedback_history';
import View_User_Data from 'view/user_data';
import Modals from 'root/modals';
import {changeFeedbacksDueDate} from 'service/feedback';

export default View.extend({
    views: {
        history: {},
        user_data: {}
    },

    events: {
        'click .dropdown-category li'         : 'changeCategory',
        'click .dropdown-feedback-type li'    : 'changeFeedbackType',
        'click .dropdown-priority li'         : 'changeFeedbackPriority',
        'click .dropdown-feedback-approve li' : 'onApproveFeedback',
        'click .category-delete'              : 'onDeleteCategory',
        'click .hr-toggle'                    : 'toggleDetails',
        'click .unmerge-feedback'             : 'onUnmergeFeedback',
        'click .view-primary-feedback'        : 'onOpenPrimaryFeedback',
        'click .manage-categories'            : 'onManageCategories',
        'click .pick-due-date'                : 'pickDueDate',
        'change input[name="feedback_due_date"]' : 'onChangeFeedbacksDueDate'
    },

    dom_handlers: {
        changeCategory: function(e) {
            var category = $(e.currentTarget).data('name');

            var action;
            var categories = [];

            if (!this.model.get('category')) {
                action = 'addCategory';
                categories.push(category);
            } else if (this.model.get('category').split(',').indexOf(category) === -1) {
                action = 'addCategory';

                categories = this.model.get('category').split(',');
                categories.push(category);
            } else {
                action = 'deleteCategory';

                _.each(this.model.get('category').split(','), function(category_name) {
                    if (category_name !== category) {
                        categories.push(category_name);
                    }
                }, this);
            }

            Cache.app.request({
                action: 'feedback/' + action,
                context: this,
                data: {
                    feedback_ids : [this.model.id],
                    category_name: category
                }
            });

            if (categories.length) {
                categories = categories.join(',');
            } else {
                categories = '';
            }

            this.model.set({category: categories});

            UI.success('Category updated');
        },

        changeFeedbackType: function(e) {
            var feedback_type = parseInt($(e.currentTarget).data('val'), 10);

            Cache.app.request({
                action: 'feedback/setFeedbackType',
                context: this,
                data: {
                    ids           : [this.model.id],
                    feedback_type : feedback_type
                }
            });

            this.model.set('feedback_type', feedback_type);
            UI.success('Feedback type changed to ' + this.model.getFeedbackTypeName());
        },

        changeFeedbackPriority: function(e) {
            var priority = $(e.currentTarget).data('priority');

            if (!priority) {
                return;
            }

            if (priority === this.model.get('priority')) {
                return;
            }

            Cache.app.request({
                action: 'feedback/setPriority',
                context: this,
                data: {
                    ids      : [this.model.id],
                    priority : priority
                }
            });

            this.model.set({priority: priority});
            UI.success('Priority updated');
        },

        onDeleteCategory: function(e) {
            var category = $(e.currentTarget).prev('span').text();

            var categories = this.model.get('category').split(',');
            var index = categories.indexOf(category);

            if (index === -1) {
                return;
            }

            categories.splice(index, 1);

            Cache.app.request({
                action: 'feedback/deleteCategory',
                data: {
                    feedback_ids  : [this.model.id],
                    category_name : category
                }
            });

            this.model.set('category', categories.join(','));
            UI.success('Category removed');
        },

        onApproveFeedback: function(e) {
            var is_approved = $(e.currentTarget).data('val') == 1;

            if (is_approved === this.model.get('is_portal_approved')) {
                return;
            }

            this.model.set('is_portal_approved', is_approved);

            if (is_approved) {
                Cache.app.request({
                    action: 'feedback/approveForPortal',
                    data: {
                        feedback_id: this.model.id
                    },
                    success: function() {
                        UI.success('Feature approved');
                    }
                });
            } else {
                Cache.app.request({
                    action: 'feedback/approveForPortal',
                    data: {
                        feedback_id: this.model.id
                    },
                    success: function() {
                        UI.success('Feature unapproved');
                    }
                });
            }
        },

        toggleDetails: function(e) {
            $(e.currentTarget).toggleClass('collapsed');
            $(e.currentTarget).next('div').toggle();
        },

        onUnmergeFeedback: function(e) {
            e.preventDefault();
            Modals.unmergeFeedback(this.model.id);
        },

        onOpenPrimaryFeedback: function(e) {
            e.preventDefault();

            var primary_feedback_id = this.model.get('primary_feedback_id');

            this.trigger('openFeedback', primary_feedback_id);
        },

        onManageCategories: function() {
            Modals.projectSettings(this.model.get('project_id'));
        },

        pickDueDate: function(e) {
            var type = $(e.currentTarget).data('type');
            if (type === 'tomorrow' || type === 'next_monday') {
                this.doChangeFeedbacksDueDate(type);
            } else if (type === 'clear') {
                this.doChangeFeedbacksDueDate('clear');
            } else {
                this.$el.find('input[name="feedback_due_date"]').get(0).showPicker();
            }
        },

        onChangeFeedbacksDueDate: function(e) {
            var due_date = $(e.currentTarget).val();
            this.doChangeFeedbacksDueDate(due_date);
        }
    },

    initialize: function() {
        this.listenTo(this.model, 'change:workflow', this.loadHistory);
        this.listenTo(this.model, 'change:priority', this.loadHistory);
        this.listenTo(this.model, 'change:user_id',  this.loadHistory);

        this.listenTo(this.model, 'change:category',           this.renderDetails);
        this.listenTo(this.model, 'change:category',           this.renderTaskDetails);
        this.listenTo(this.model, 'change:feedback_type',      this.renderTaskDetails);
        this.listenTo(this.model, 'change:workflow',           this.renderTaskDetails);
        this.listenTo(this.model, 'change:priority',           this.renderTaskDetails);
        this.listenTo(this.model, 'change:is_portal_approved', this.renderTaskDetails);
        this.listenTo(this.model, 'change:primary_feedback_id', this.renderTaskDetails);
        this.listenTo(this.model, 'change:merged_feedback_ids', this.renderTaskDetails);
        this.listenTo(this.model, 'change:due_date',            this.renderTaskDetails);

        this.listenTo(Cache.feedback_screenshot, 'add',    this.renderDetails);
        this.listenTo(Cache.feedback_screenshot, 'remove', this.renderDetails);
        this.listenTo(Cache.feedback_screenshot, 'change', this.renderDetails);

        if (this.showUserData()) {
            this.listenTo(this.model, 'change:user_identification', this.renderUserData);
            this.views.user_data = new View_User_Data({identification: this.model.get('user_identification')});
        }
    },

    doChangeFeedbacksDueDate: function(due_date) {
        var selected_feedback = Cache.feedback.where({selected: true});

        // due_date is either 'tomorrow', 'next_monday', or a date string
        // do validation checks here
        if (!due_date && due_date !== 'tomorrow' && due_date !== 'next_monday' && due_date !== 'clear' && isNaN((new Date(due_date)).getTime())) {
            return;
        }

        changeFeedbacksDueDate([this.model.id], due_date, (response) => {
            if (response && response.length > 0) {
                // update the due date of the selected feedback
                var updated_feedback = _.findWhere(response, {feedback_id: this.model.id});

                if (updated_feedback) {
                    this.model.set('due_date', updated_feedback.due_date);
                }

                if (due_date === 'clear') {
                    UI.success('Due date removed');
                } else {
                    UI.success('Due date updated');
                }
            }
        });
    },

    showUserData: function() {
        if (Cache.real_user_id && !Cache.app.isClient() && !this.model.isDesign() && !this.model.isPdf() && !this.model.isVideoUpload()) {
            return true;
        } else {
            return false;
        }
    },

    loadHistory: function() {
        if (!Cache.real_user_id || Cache.app.isClient()) {
            return;
        }

        Cache.app.request({
            action: 'history/loadFeedbackHistory',
            context: this,
            data: {feedback_id: this.model.id},
            success: function(response) {
                if (response.length === _.size(this.views.history)) {
                    return;
                }

                var history_collection = new Collection_History(response);

                _.each(this.views.history, function(view) {
                    view.remove();
                });

                history_collection.each(function(model) {
                    this.views.history['_' + model.id] = new View_Feedback_History({model: model});
                    this.views.history['_' + model.id].render().$el.appendTo(this.$el.find('.region-activities'));
                }, this);

                if (response.length) {
                    this.$el.find('.activity-details').show();
                } else {
                    this.$el.find('.activity-details').hide();
                }
            }
        });
    },

    renderTaskDetails: function() {
        if (!Cache.real_user_id || this.model.isDesign() || this.model.isPdf() || this.model.isVideoUpload()) {
            return;
        }

        var portal = Cache.portal.findWhere({project_id: this.model.get('project_id')});

        var categories = '';
        var selected_categories = [];
        if (this.model.get('category')) {
            this.model.get('category').split(',').forEach((category_name) => {
                categories += '<span class="category-name badge-small badge-btn badge-primary-invert font-weight-medium">' +
                                  '<span>' + Util.htmlEntities(category_name) + '</span>' +
                                  '<button type="button" class="category-delete"><i class="far fa-times"></i></button>' +
                              '</span>';
                selected_categories.push(category_name);
            });
        }

        var category_options = '';
        Cache.feedback_category.where({project_id: this.model.get('project_id')}).forEach((model) => {
            if (selected_categories.indexOf(model.get('name')) === -1) {
                category_options += '<li data-name="' + model.escape('name') + '" title="' + model.escape('name') + '"><span class="icon-placeholder"></span>' + model.escape('name') + '</li>';
            } else {
                category_options += '<li data-name="' + model.escape('name') + '" title="' + model.escape('name') + '"><i class="far fa-check"></i>' + model.escape('name') + '</li>';
            }
        });

        var html = '';

        if (Cache.app.isClient()) {
            html += '<div class="title">Type:</div>' +
                    '<div class="value">' + this.model.getFeedbackTypeName() + '</div>' +
                    '<div class="title">Priority:</div>' +
                    '<div class="value">' +
                        '<span class="priority-status-' + this.model.get('priority').toLowerCase() + '"></span>' +
                        '<span>' + Util.cap(this.model.get('priority')) + '</span>' +
                    '</div>';
        } else if (this.model.isMergedFeedback()) {
            html += '<div class="full">' +
                        '<p class="merged-tips info"><i class="fa-duotone fa-circle-info float-left"></i><span>This feedback has been merged into another feedback.</span></p>' +
                        '<p class="merged-feedback-tools"><a href="#" class="primary unmerge-feedback">Unmerge</a><b class="info"> &bull; </b><a href="#" class="primary view-primary-feedback">View primary feedback</a></p>'
                    '</div>';
        } else {
            html += '<div class="title title-medium">Type:</div>' +
                        '<div class="value">' +
                            '<div class="button-dropdown button-dropdown-left" data-append="true">' +
                                '<button type="button" class="dropdown-select" style="min-width:162px;">' + this.model.getFeedbackTypeName() + '</button>' +
                                '<div>' +
                                    '<ul class="dropdown dropdown-select dropdown-feedback-type">' +
                                        '<li data-val="' + Constants.FEEDBACK_BUG             + '"' + (this.model.get('feedback_type') === Constants.FEEDBACK_BUG             ? ' class="selected"' : '') + '>Bug</li>' +
                                        '<li data-val="' + Constants.FEEDBACK_FEATURE_REQUEST + '"' + (this.model.get('feedback_type') === Constants.FEEDBACK_FEATURE_REQUEST ? ' class="selected"' : '') + '>Idea</li>' +
                                        '<li data-val="' + Constants.FEEDBACK_GENERAL         + '"' + (this.model.get('feedback_type') === Constants.FEEDBACK_GENERAL         ? ' class="selected"' : '') + '>General</li>' +
                                    '</ui>' +
                                '</div>' +
                            '</div>' +
                        '</div>' +

                        (portal && this.model.get('feedback_type') ===  Constants.FEEDBACK_FEATURE_REQUEST ?
                        '<div class="title title-medium">Portal visibility:</div>' +
                        '<div class="value">' +
                            '<div class="button-dropdown button-dropdown-left" data-append="true">' +
                                '<button type="button" class="dropdown-select" style="min-width:162px;">' + (this.model.get('is_portal_approved') ? '<i class="far fa-eye text-small text-info"></i> Yes' : '<i class="far fa-eye-slash text-small text-info"></i> No') + '</button>' +
                                '<div>' +
                                    '<ul class="dropdown dropdown-select dropdown-feedback-approve">' +
                                        '<li data-val="1"' + (this.model.get('is_portal_approved') ? ' class="selected"' : '') + '>Yes</li>' +
                                        '<li data-val="0"' + (this.model.get('is_portal_approved') ? '' : ' class="selected"') + '>No</li>' +
                                    '</ui>' +
                                '</div>' +
                            '</div>' +

                            '<span class="text-small text-info margin-left-8">' +
                                (portal.isFeedbackVisible(this.model) ?
                                '<a href="' + portal.getUrl() + '/idea/' + this.model.id + '" target="portal" class="text-info"><i class="fas fa-external-link tooltip" data-title="Open in ideas portal"></i></a>' :
                                (this.model.get('is_portal_approved') ?
                                '<i class="fas fa-eye-slash tooltip" data-title="Not visible in portal"></i>' : '')) +
                            '</span>' +
                        '</div>' : '') +

                        '<div class="title title-medium">Priority:</div>' +
                        '<div class="value">' +
                            '<div class="button-dropdown button-dropdown-left" data-append="true">' +
                                '<button type="button" class="dropdown-select" style="min-width:162px;">' +
                                    '<span class="priority-status-' + this.model.get('priority').toLowerCase() + '"></span>' +
                                    '<span>' + Util.cap(this.model.get('priority')) + '</span>' +
                                '</button>' +
                                '<div>' +
                                    '<ul class="dropdown dropdown-select dropdown-priority">' +
                                        '<li' + (this.model.get('priority') === 'urgent'  ? ' class="selected"' : '') + ' data-priority="urgent"><span class="priority-status-urgent"></span>Urgent</li>' +
                                        '<li' + (this.model.get('priority') === 'high'    ? ' class="selected"' : '') + ' data-priority="high"><span class="priority-status-high"></span>High</li>' +
                                        '<li' + (this.model.get('priority') === 'neutral' ? ' class="selected"' : '') + ' data-priority="neutral"><span class="priority-status-neutral"></span>Neutral</li>' +
                                        '<li' + (this.model.get('priority') === 'low'     ? ' class="selected"' : '') + ' data-priority="low"><span class="priority-status-low"></span>Low</li>' +
                                    '</ul>' +
                                '</div>' +
                            '</div>' +
                        '</div>';

        }

        if (!this.model.isMergedFeedback()) {
            html += '<div class="title">Category:</div>' +
                    '<div class="value value-normal">' +
                        (Cache.app.isClient() ? (categories || '-') :
                        (categories ? categories : '') +
                        '<div class="button-dropdown v-align-top" data-append="true">' +
                            '<button type="button" class="text-primary"><i class="fad fa-plus-circle"></i></button>' +
                            '<div>' +
                                '<div class="dropdown-search">' +
                                    '<input type="text" class="solid compact" placeholder="Search by name">' +
                                '</div>' +
                                '<ul class="dropdown dropdown-category">' + category_options + '</ul>' +
                                (Cache.app.isAdmin() ?
                                '<div>' +
                                    '<button type="button" class="manage-categories text-primary-small small"><i class="fa-solid fa-cog"></i>Manage Categories</button>' +
                                '</div>' : '') +
                            '</div>' +
                        '</div>') +
                    '</div>' ;

            var is_overdue = this.model.isOverdue();
            var is_due_today = this.model.isDueToday();

            var due_date = this.model.get('due_date');
            var due_date_text = '';
            var due_date_tooltip = '';

            if (due_date) {
                if (is_overdue) {
                    due_date_text = '<div class="text-danger"><i class="text-danger fa-regular fa-calendar-circle-exclamation"></i> ' + Util.moment(due_date, 'DD MMM YYYY', false, false) + '</div>';
                    due_date_tooltip = 'Overdue';
                } else if (is_due_today) {
                    due_date_text = '<div class="text-warning"><i class="text-warning fa-regular fa-calendar-circle-exclamation"></i> ' + Util.moment(due_date, 'DD MMM YYYY', false, false) + '</div>';
                    due_date_tooltip = 'Due Today';
                } else {
                    due_date_text = '<i class="fa-regular fa-calendar-clock text-icon"></i> ' + Util.moment(due_date, 'DD MMM YYYY', false, false);
                }
            }

            var due_date_options =
            (
                this.model.get('due_date') ?
                (
                    '<li class="pick-due-date" data-type="clear">Clear due date</li>' +
                    '<li class="separator"></li>'
                ) : ''
            ) +
            '<li class="pick-due-date" data-type="tomorrow">' +
                '<div class="flex-between">' +
                    '<span>Tomorrow</span>' +
                    '<span class="text-info margin-left-24">' + Util.getTomorrow('ddd') + '</span>' +
                '</div>' +
            '</li>' +
            '<li class="pick-due-date" data-type="next_monday">' +
                '<div class="flex-between">' +
                    '<span>Next week</span>' +
                    '<span class="text-info margin-left-24">' + Util.getNextMonday('ddd') + '</span>' +
                '</div>' +
            '</li>' +
            '<li class="pick-due-date">Pick a date</li>';

            // Add due date
            html += '<div class="title title-medium">Due date:</div>' +
            '<div class="value position-relative">' +
                '<div class="button-dropdown button-dropdown-left" data-append="true" >' +
                    '<button type="button" class="dropdown-select dropdown-select-multiple feedback-due-date-text tooltip" data-title="' + due_date_tooltip + '" style="min-width:162px;">' +
                        (due_date_text || '<span class="placeholder-text">Select...</span>') +
                    '</button>' +
                    '<div>' +
                        '<ul class="dropdown">' +
                        due_date_options +
                        '</ul>' +
                    '</div>' +
                '</div>' +
                '<input type="date" name="feedback_due_date" class="hidden-date-picker" >' +
            '</div>';
        }

        this.$el.find('.task-details').html(html);

        Form.setData(this.$el, {
            feedback_due_date: this.model.get('due_date') ? Util.moment(due_date, 'yyyy-MM-dd', false, false) : ''
        });
    },

    renderDetails: function() {
        var unsubscribed_emails = Cache.feedback_unsubscribed_emails[this.model.id] || [];
        var unsubscribed = unsubscribed_emails.indexOf(this.model.escape('email')) !== -1;

        var categories = '';
        var selected_categories = [];
        if (this.model.get('category')) {
            this.model.get('category').split(',').forEach((category_name) => {
                categories += '<span class="category-name badge-small badge-btn badge-primary-invert font-weight-medium">' +
                                  '<span>' + Util.htmlEntities(category_name) + '</span>' +
                                  '<button type="button" class="category-delete"><i class="far fa-times"></i></button>' +
                              '</span>';
                selected_categories.push(category_name);
            });
        }

        var device  = ''
        var os      = ''
        var os_icon = '';

        if (this.model.isTablet()) {
            device += ' (Tablet)';
        } else if (this.model.isPhone()) {
            device += ' (Mobile)';
        }

        os = this.model.getOs();

        if (this.model.isAndroid()) {
            os_icon = '<i class="fab fa-android text-android"></i> ';
        } else if (this.model.isApple()) {
            os_icon = '<i class="fab fa-apple"></i> ';
        } else if (this.model.isWindowsPhone() || this.model.isWindows()) {
            os_icon = '<i class="fab fa-windows text-windows"></i> ';
        } else if (this.model.isLinux()) {
            os_icon = '<i class="fab fa-linux"></i> ';
        } else {
            os_icon = '';
        }

        if (!os.trim() && !os_icon && !device) {
            device  = '-';
        }

        var category_options = '';
        Cache.feedback_category.where({project_id: this.model.get('project_id')}).forEach((model) => {
            if (selected_categories.indexOf(model.get('name')) === -1) {
                category_options += '<li data-name="' + model.escape('name') + '" title="' + model.escape('name') + '"><span class="icon-placeholder"></span>' + model.escape('name') + '</li>';
            } else {
                category_options += '<li data-name="' + model.escape('name') + '" title="' + model.escape('name') + '"><i class="far fa-check"></i>' + model.escape('name') + '</li>';
            }
        });

        var reporter = '';
        if (this.model.get('email') && this.model.get('name')) {
            reporter = '<div class="ellipsis">' + this.model.escape('name') + '</div>' +
                       '<div class="ellipsis">' +
                           (unsubscribed ? '<i class="fad fa-bell-slash tooltip" data-title="Reporter has opted out of email updates"></i> ' : '') +
                           '<a href="mailto:' + this.model.escape('email') + '">' + this.model.escape('email') + '</a>' +
                       '</div>';
        } else if (!this.model.get('email') && !this.model.get('name')) {
            reporter = 'anonymous';
        } else if (this.model.get('name')) {
            reporter = this.model.escape('name');
        } else if (this.model.get('email')) {
            reporter = (unsubscribed ? '<i class="fad fa-bell-slash tooltip" data-title="Reporter has opted out of email updates"></i> ' : '') +
                       '<a class="ellipsis" href="mailto:' + this.model.escape('email') + '">' + this.model.escape('email') + '</a>';
        }

        var content = '';

        if (this.model.isDesign()) {
            content += '<div class="title">Date:</div>' +
                        '<div class="value">' + Util.moment(this.model.get('time'), 'DD MMM YYYY hh:mm a') + '</div>' +
                        (Cache.real_user_id ?
                        '<div class="title">Uploaded by:</div>' +
                        '<div class="value">' + reporter + '</div>' : '') +
                        '<div class="title">Images:</div>' +
                        '<div class="value">';

            _.each(Cache.feedback_screenshot.where({feedback_id: this.model.id}), function(model, index) {
                content += '<div class="ellipsis margin-bottom-4">' +
                                '<a target="download" download="' + model.escape('name') + '" href="' + model.escape('url') + '">Version ' + (index + 1) + '</a>' +
                            '</div>' +
                            (model.get('website_url') ?
                            '<div class="line-height-reset ellipsis text-small info"><i class="far fa-fw fa-link"></i> ' + model.escape('website_url') + '</div>' : '') +
                            '<div class="line-height-reset info margin-bottom-4 text-small"><i class="far fa-fw fa-crop-alt"></i> ' + model.get('window_x') + ' x ' + model.get('window_y')  + '</div>';
            });

            content += '</div>';


            if (Cache.real_user_id) {
            content += '<div class="title">Category:</div>' +
                        '<div class="value value-normal">' +
                            (Cache.app.isClient() ? (categories || '-') :
                            (categories ? categories : '') +
                            '<div class="button-dropdown v-align-middle" data-append="true">' +
                                '<button type="button" class="text-primary"><i class="fad fa-plus-circle"></i></button>' +
                                '<div>' +
                                    '<div class="dropdown-search">' +
                                        '<input type="text" class="solid compact" placeholder="Search by name">' +
                                    '</div>' +
                                    '<ul class="dropdown dropdown-category">' + category_options + '</ui>' +
                                '</div>' +
                            '</div>') +
                        '</div>';
            }
        } else if (this.model.isPdf()) {
            content += '<div class="title">Date:</div>' +
                        '<div class="value">' + Util.moment(this.model.get('time'), 'DD MMM YYYY hh:mm A') + '</div>' +
                        (Cache.real_user_id ?
                        '<div class="title">Uploaded by:</div>' +
                        '<div class="value">' + reporter + '</div>' +
                        '<div class="title">Category:</div>' +
                        '<div class="value value-normal">' +
                            (Cache.app.isClient() ? (categories || '-') :
                            (categories ? categories : '') +
                            '<div class="button-dropdown v-align-middle" data-append="true">' +
                                '<button type="button" class="text-primary"><i class="fad fa-plus-circle"></i></button>' +
                                '<div>' +
                                    '<div class="dropdown-search">' +
                                        '<input type="text" class="solid compact" placeholder="Search by name">' +
                                    '</div>' +
                                    '<ul class="dropdown dropdown-category">' + category_options + '</ui>' +
                                '</div>' +
                            '</div>') +
                        '</div>' : '');
        } else if (this.model.isVideoUpload()) {
            content += '<div class="title">Date:</div>' +
                        '<div class="value">' + Util.moment(this.model.get('time'), 'DD MMM YYYY hh:mm a') + '</div>' +
                        (Cache.real_user_id ?
                        '<div class="title">Uploaded by:</div>' +
                        '<div class="value">' + reporter + '</div>' +
                        '<div class="title">Category:</div>' +
                        '<div class="value value-normal">' +
                            (Cache.app.isClient() ? (categories || '-') :
                            (categories ? categories : '') +
                            '<div class="button-dropdown v-align-middle" data-append="true">' +
                                '<button type="button" class="text-primary"><i class="fad fa-plus-circle"></i></button>' +
                                '<div>' +
                                    '<div class="dropdown-search">' +
                                        '<input type="text" class="solid compact" placeholder="Search by name">' +
                                    '</div>' +
                                    '<ul class="dropdown dropdown-category">' + category_options + '</ui>' +
                                '</div>' +
                            '</div>') +
                        '</div>' : '');
        } else {
            var shorten_url = '';
            if (this.model.get('page').length > 33) {
                var page_url = new URL(this.model.get('page'));
                shorten_url = page_url.pathname + page_url.search;
                if (shorten_url.length <= 1) {
                    shorten_url = this.model.get('page');
                }
            } else {
                shorten_url = this.model.get('page');
            }

            content += '<div class="title">Date:</div>' +
                        '<div class="value">' + Util.moment(this.model.get('time'), 'DD MMM YYYY hh:mm a') + '</div>' +
                        (Cache.real_user_id ?
                        '<div class="title">Reporter:</div>' +
                        '<div class="value">' + reporter + '</div>' : '') +

                        '<div class="title">Source:</div>' +
                        '<div class="value">' + Util.htmlEntities(this.model.getSource()) + '</div>' +

                        (this.model.getVoteCount() ?
                        '<div class="title">Vote:</div>' +
                        '<div class="value">' + this.model.getVoteCount() + '</div>' : '') +

                        '<div class="title">Page:' + (this.model.get('screenshot') && this.model.get('is_local') && (this.model.get('load_type') === 'web' || this.model.get('load_type') === 'intercom_messenger') ? ' <a href="https://support.userback.io/en/articles/5209187" target="_blank"><i class="fas fa-question-circle text-warning tooltip" data-title="Learn how to capture better screenshots"></i></a>' : '') + '</div>' +
                        '<div class="value">' +
                            (this.model.get('page') ?
                            '<a class="ellipsis" title="' + this.model.escape('page') + '" href="' + this.model.escape('page') + '" target="_blank">' + Util.htmlEntities(shorten_url) + '</a>' : '-') +
                        '</div>' +
                        '<div class="title">Page title:</div>' +
                        '<div class="value"><div class="ellipsis" title="' + this.model.escape('page_title') + '">' + (this.model.escape('page_title') || '-') + '</div></div>' +

                        '<div class="title">Rating:</div>' +
                        '<div class="value rating-details">' + this.model.getRatingIcon() + '</div>' +
                        '<div class="title">System:</div>' +
                        '<div class="value">' + os_icon + os + device + '</div>' +
                        '<div class="title">Browser:</div>' +
                        '<div class="value">' + (this.model.getBrowserIcon() || '') + this.model.getBrowser('-') + '</div>' +
                        '<div class="title">Window size:</div>' +
                        '<div class="value">' + (this.model.get('window_x') && this.model.get('window_y') ? this.model.get('window_x') + ' x ' + this.model.get('window_y') : '-') + '</div>' +
                        '<div class="title">Resolution:</div>' +
                        '<div class="value">' + (this.model.get('resolution_x') && this.model.get('resolution_y') ? this.model.get('resolution_x') + ' x ' + this.model.get('resolution_y') : '-') + '</div>' +
                        '<div class="title">DPI:</div>' +
                        '<div class="value">' + (this.model.get('dpi') || '-') + '</div>' +
                        '<div class="title">Color depth:</div>' +
                        '<div class="value">' + (this.model.get('colour_depth') ? this.model.get('colour_depth') + '-bit' : '-') + '</div>' +
                        '<div class="title">Location:</div>' +
                        '<div class="value">' + (this.model.get('city') ? this.model.get('city') + ' ' + this.model.get('country') + ' ' + this.model.get('postal') : '-') + '</div>';
        }

        this.$el.find('.session-details').html(content);

        setTimeout(() => {
            this.$el.find('.session-details .grid-4.info').each(function() {
                if ($(this).height() > 50) {
                    $(this).addClass('grid-overflow');
                }
            });
        });
    },

    renderUserData: function() {
        if (!this.showUserData()) {
            return;
        }

        this.views.user_data.setId(this.model.get('user_identification'));
        this.views.user_data.render();
    },

    renderCustomData: function() {
        var content = '';

        _.each(this.model.get('custom_data'), (data, label) => {
            content +=
                '<div class="title" title="' + Util.htmlEntities(label) + '">' + Util.htmlEntitiesWithA(label) + ':</div>' +
                '<div class="value">' + (Util.htmlEntitiesWithA(data, true) || '&mdash;') + '</div>';
        });

        if (!_.size(this.model.get('custom_data'))) {
            content = 'No custom data submitted. <a target="help" rel="noopener" href="https://support.userback.io/en/articles/5209197-add-a-custom-field-to-your-widget?q=custom+data">Find out more</a>.';
        }

        this.$el.find('.custom-data').html(content);

        this.$el.find('.custom-data').toggleClass('empty', !_.size(this.model.get('custom_data')));
    },

    render: function() {
        var tab_name = '';
        if (this.model.isPdf()) {
            tab_name = 'PDF Info';
        } else if (this.model.isDesign()) {
            tab_name = 'Design Info';
        } else if (this.model.isVideoUpload()) {
            tab_name = 'Video Info';
        } else {
            tab_name = 'Session Info';
        }

        var content = '';

        content += '<div class="task-details"></div>' +

                    '<div class="hr hr-toggle small">' +
                        '<span class="font-weight-semibold text-info text-medium">' + tab_name + '</span>' +
                    '</div>' +
                    '<div class="session-details margin-top-4"></div>' +

                    (Cache.real_user_id &&
                    !Cache.app.isClient() &&
                    !this.model.isDesign() &&
                    !this.model.isPdf() &&
                    !this.model.isVideoUpload() ?
                    '<div class="hr hr-toggle small">' +
                        '<span class="font-weight-semibold text-info text-medium">User Data</span>' +
                    '</div>' +
                    '<div class="user-details margin-top-4"></div>' : '') +

                    (Cache.real_user_id &&
                    !Cache.app.isClient() &&
                    !this.model.isDesign() &&
                    !this.model.isPdf() &&
                    !this.model.isVideoUpload() ?
                    '<div class="hr hr-toggle small">' +
                        '<span class="font-weight-semibold text-info text-medium">Custom Data</span>' +
                    '</div>' +
                    '<div class="custom-data margin-top-4"></div>' : '') +

                    '<div class="activity-details">' +
                        '<div class="hr hr-toggle small">' +
                            '<span class="font-weight-semibold text-info text-medium">Activities</span>' +
                        '</div>' +
                        '<div class="region-activities margin-top-4"></div>' +
                    '</div>';

        this.$el.html(content);

        this.renderTaskDetails();
        this.renderDetails();

        if (this.showUserData()) {
            this.views.user_data.render().$el.appendTo(this.$el.find('.user-details'));
        }

        this.renderCustomData();

        return this;
    }
});
